import { render } from "./IconPostOrder.vue?vue&type=template&id=bfb47a98"
import script from "./IconPostOrder.vue?vue&type=script&lang=js"
export * from "./IconPostOrder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__